import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { state } from 'aws-cognito-redux-saga'
import { TableBody } from 'material-ui';

const style = {
  page: {},
  layout: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center'
  },
  heading: {
    textAlign: 'center',
    fontSize: '48px',
    margin: '64px'
  },
  label: {
    fontSize: '24px',
    margin: '8px 0',
    color: 'rgb(0,64,128)'
  },
  token: {
    overflow: 'auto',
    overflowWrap: 'break-word',
    fontSize: '16px',
    width: '90vw'
  }
}

const url = 'https://lyru271nfe.execute-api.us-west-1.amazonaws.com/production/user-data/';
const key = "TetRg4sVfY6tObYQoks7e5VFUfKCqsUc1znNTgMC";


export class ProtectedComponent extends React.Component {

  static propTypes = {
    isSignedIn: PropTypes.string,
    auth: PropTypes.object
  }


  getUserSensorData = (auth) => {
    const headers = {
      "x-api-key": key,
      "Content-Type": "application/json",
      "Authorization": auth.info.idToken.jwtToken
    };
    const body = {
      enduserdata: [
        {
          "APICALL": "get_all_user_data_by_user",
        }
      ]
    };
      
    fetch(url,{method:'POST'},{body:body},{headers:headers})
    .then((response) => response.json())
      .then((responseJson) => {
        alert(JSON.stringify(responseJson))
         console.log(responseJson);
         this.setState({
            data: responseJson
         })
      })
      .catch((error) => {
        console.error(error);
     });
    }

   renderAuthInfo(auth) {
    return (
      <div style={style.token}>
        <div style={style.label}>Access Token</div>
        <div>{auth.info.accessToken.jwtToken}</div>
        <div style={style.label}>ID Token</div>
        <div>{auth.info.idToken.jwtToken}</div>
        <div style={style.label}>Refresh Token</div>
        <div>{auth.info.refreshToken.token}</div>
      </div>
    )
  }

  render() {
    const { auth } = this.props

    return (
      <div style={style.page}>
        <div style={style.layout}>
          <div style={style.heading}>Protected Page</div>

          {auth.isSignedIn === state.AUTH_SUCCESS
            ? this.getUserSensorData(auth)
            : null}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Protected/Protected.js